declare interface PerformanceApi {
  mark?: (name: string) => PerformanceMark | undefined;
}

declare interface PerformanceMark {
  startTime: number;
}

declare global {
  interface Window {
    performance?: PerformanceApi | undefined;
  }
}

export function getTiming(eventName: string) {
  if (
    typeof window === 'undefined' ||
    !window.performance ||
    !window.performance.mark
  )
    return 0;

  const mark = window.performance.mark(eventName);

  if (mark) {
    return mark.startTime;
  }

  const entries = window.performance.getEntriesByName(eventName);
  if (entries && entries.length > 0) {
    return entries[0].startTime;
  }

  return 0;
}
